import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16.667 15" {...props}><path xmlns="http://www.w3.org/2000/svg" fill={props.color || "#000"} d="M0 15V5h4.583v10zm6.042 0V0h4.583v15zm6.041 0V6.667h4.584V15z" /></svg>;
export default Component;